export const TemperatureUp = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 0 15 11.278l-1.75-.023-5.765-8.63-5.736 8.63H0z"
      fill="#979797"
      fillRule="nonzero"
    />
  </svg>
);
